import React from 'react'

import FilterList from './FilterList'

const FiatCurrency = ({
  state, currencies, setFiatCurrency, className, children, blank_modal_src,
  widget_instance_token,
}) => {
  if (currencies.length <= 1) return <span className={className}>{children}</span>

  return (
    <FilterList
      id={`fiatCurrency:${widget_instance_token}`}
      title="Fiat currencies"
      value={state.fiat_currency}
      onChange={setFiatCurrency}
      blank_modal_src={blank_modal_src}
      options={currencies.map(currency => ({
        label: currency.name,
        value: currency.iso_code,
      }))}
      render={({ open }) => (
        <button
          type="button"
          className={`btn btn-link dropdown-toggle text-decoration-none border-0 p-0 ${className}`}
          style={{ lineHeight: 'inherit' }}
          onClick={open}
        >{children}</button>
      )}
    />
  )
}

export default FiatCurrency
